export const LabelAnnual = () => {
  return <label className="nj-label-annual" data-e2e="label-annual">Annual</label>;
};
